import {makeAutoObservable} from 'mobx';
import MicrolessonsRepository from '../../../../data/repositories/MicrolessonsRepository';
import LoadingModule from '../../../../modules/LoadingModule/LoadingModule';

class MicrolessonsPreviewStore {
  private microlessonsRepository = new MicrolessonsRepository();

  private loadingModule = new LoadingModule();

  constructor() {
    makeAutoObservable(this);
  }

  public get isLoading() {
    return this.loadingModule.isLoading;
  }

  public async getMicrolessonsPreview(
    organizationId: string,
    lessonId: string,
  ) {
    this.loadingModule.startLoading();
    const result = await this.microlessonsRepository.getMicrolessonPreview(
      organizationId,
      lessonId,
    );
    this.loadingModule.endLoading();
    if (result.success && result.data) {
      return result.data;
    }
  }
}

export default MicrolessonsPreviewStore;
